import React, {useState, useEffect} from "react";
import Pagination from "./Pagination";
import MyPageAttendCard2 from "./MyPageAttendCard2";
import assets from "../assets/imgs";

function MyPageShowAllBox({title, data, retailText, onClose}){
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const itemsPerPage = 7; // 페이지당 항목 수
  // 현재 페이지에 표시할 항목 계산
  const startIndex = (currentPage - 1) * itemsPerPage;
  const items = data.slice(startIndex, startIndex + itemsPerPage);

  // 총 페이지 수 계산
  const totalPages = Math.ceil(data.length / itemsPerPage);

  
  const handleOverlayClick = (e)=>{
    if(e.target === e.currentTarget){
      onClose();
    }
  }

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return(
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.container}>
        <div style={styles.titleSection} className="font-body1-semibold">
          <p>{title}</p>
          <div style={styles.xBox} onClick={onClose}>
            <assets.icons.icon_x/>
          </div>
        </div>
        <div style={styles.body}>
          {items.map((item, index) => (
            <MyPageAttendCard2 key={item.id} program={item} retailText={retailText}/>
          ))}
        </div>
        {/* 페이지네이션 */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          style= {{position: "absolute",
            bottom: "25px",
            left: "50%",
            transform: "translateX(-50%)",}}
        />
      </div>
    </div>
  );
}

const styles ={
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  container: {
    display:"flex",
    flexDirection: "column",
    gap:"24px",
    width: "740px",
    height: "850px",
    boxSizing: "border-box",
    padding: "32px",
    position: "relative",
    backgroundColor: "white",
    borderRadius :"25px"
  },
  titleSection: {
    display:"flex",
    alignItems: "center",
    justifyContent: "space-between"
  },  
  body:{
    display:"flex",
    flexDirection:"column",
    gap:"16px"
  },
  xBox:{
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    cursor:"pointer",
    width: "20px",
    height:"20px"
  }
}

export default MyPageShowAllBox;
